import { isClientSide } from '@js/common/utils'

export const DEFAULT_LOCALE = 'DE-de'

export const BUDGET_CONSTANTS = isClientSide
  ? window.SherlockContainer.BudgetCalculator
  : {
      defaultMonthlyRate: 800,
      yearlyInterestRate: 0.0165,
      fixedInterestRatePeriodYears: 10,
      mortgageTermYears: 35,
      equity: 0.2,
      extraCosts: 0.2,
      paymentToPrincipal: 0.02
    }

export const IMAGE_ASPECT_RATIO = 4 / 3
